<template>
  <div>
    <div class="footer-line"></div>
    <div class="footer-square left"></div>
    <div class="footer-square right"></div>
  </div>
</template>

<script>
export default {
  name: "TheDotLine",
};
</script>
<style lang="scss" scoped>
.footer-line {
  position: absolute;
  z-index: 100;
  width: 100%;
  bottom: 33vh;
  border-top: 1px dashed #000000;
}

.footer-square {
  position: absolute;
  bottom: calc(33vh - 7.5px);
  width: 15px;
  height: 15px;
  background-color: #000000;
  transform: rotate(45deg);
  z-index: 100;
}

.footer-square.left {
  margin-left: -7.5px;
}

.footer-square.right {
  margin-left: calc(100% - 11.5px);
  width: 0;
  height: 0;
  bottom: calc(33vh - 12px);
  background: none;
  -webkit-transform: rotate(0deg);
  transform: rotate(0deg);
  border-top: 12px solid transparent;
  border-right: 11px solid #000000;
  border-bottom: 12px solid transparent;
}
</style>
